import { render } from "./BgConstructorImportExport.vue?vue&type=template&id=78efd78e&ts=true"
import script from "./BgConstructorImportExport.vue?vue&type=script&lang=ts"
export * from "./BgConstructorImportExport.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__